import React from "react";
import { Box, Typography, Button, Stack, alpha, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SportsCricketOutlinedIcon from "@mui/icons-material/SportsCricketOutlined";
import AlignHorizontalLeftOutlinedIcon from "@mui/icons-material/AlignHorizontalLeftOutlined";
import { dashIconWellSx, getDashAccent } from "../myDashboardStyles";

export default function CriticalPathWidget({ editing }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const accent = getDashAccent(
    "widget-critical-path",
    "manufacturing",
    theme.palette.mode,
  );

  const actionBtnSx = (theme, filled) => ({
    justifyContent: "flex-start",
    textTransform: "none",
    fontWeight: 700,
    borderRadius: 2,
    py: 1.1,
    ...(filled
      ? {
          bgcolor: accent,
          boxShadow: `0 6px 16px ${alpha(accent, 0.32)}`,
          color: "#fff",
          "&:hover": {
            bgcolor: accent,
            filter:
              theme.palette.mode === "dark"
                ? "brightness(1.08)"
                : "brightness(0.95)",
          },
        }
      : {
          borderColor: alpha(accent, theme.palette.mode === "dark" ? 0.55 : 0.4),
          color: accent,
          backgroundColor: alpha(
            theme.palette.background.paper,
            theme.palette.mode === "dark" ? 0.35 : 0.5,
          ),
          "&:hover": {
            borderColor: accent,
            backgroundColor: alpha(
              accent,
              theme.palette.mode === "dark" ? 0.16 : 0.08,
            ),
          },
        }),
  });

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        p: 1.75,
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
        <Box
          sx={(theme) => ({
            ...dashIconWellSx(theme, accent),
            width: 38,
            height: 38,
            borderRadius: "12px",
          })}
        >
          <SportsCricketOutlinedIcon sx={{ fontSize: 18 }} />
        </Box>
        <Typography variant="subtitle2" fontWeight={800} letterSpacing={0.1}>
          {t("myDashboard.widgetCriticalPath")}
        </Typography>
      </Box>

      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.45 }}>
        {t("myDashboard.criticalPathHint")}
      </Typography>

      <Stack spacing={1} sx={{ mt: "auto" }}>
        <Button
          variant="contained"
          disabled={editing}
          startIcon={<SportsCricketOutlinedIcon />}
          onClick={() => navigate("/criticalPathHorizontal1")}
          sx={(theme) => actionBtnSx(theme, true)}
        >
          {t("sidebar.criticalPathGant")}
        </Button>
        <Button
          variant="outlined"
          disabled={editing}
          startIcon={<AlignHorizontalLeftOutlinedIcon />}
          onClick={() => navigate("/criticalPathHorizontal")}
          sx={(theme) => actionBtnSx(theme, false)}
        >
          {t("sidebar.criticalPathGlobal")}
        </Button>
      </Stack>
    </Box>
  );
}
